import strings from "translate/language";
import envJson from "../env.json";

export const GLOBAL_URL = envJson.BASE_URL;

export const JW_LOGIN = "api";

export const JW_PASSWORD = "8a09b13792174b21ef6b6d2302ac420f9ac5688b"; //PROD
// export const JW_PASSWORD = "c519013b5310cab0a07d0976411827ca937431ef"; //DEMO API

export const emailEndPoint = "@justo.co.in";

export const visitorStatus = [
  strings.notavailable,
  "New lead",
  "In Followup",
  "Ready to visit",
  "Booking",
  "Registration",
  "Visit cancelled",
  "Ready to book",
];

export const FollowupType = [
  strings.notavailable,
  "Lead",
  "Appointment",
  "Booking",
  "Registration",
];

export const AppointmentStatus = [
  strings.notavailable,
  "Upcoming",
  "Revisit",
  "Complete",
  "Cancelled",
  "Reschedule",
  "Not Fit for Sale",
  "",
  "",
  "",
  "Follow UP",
];
export const AppointmentStatusColor = [
  "#000",
  "#ff9f40",
  "green",
  "green",
  "red",
  "red",
  "red",
  "",
  "",
  "",
  "darkblue",
];
export const newUploadStatus = [
  strings.notavailable,
  "Pending",
  "Verify",
  "Close",
];
export const bookingStatus = [
  strings.notavailable,
  "Ready To Book",
  "Booking",
  "Completed",
  "Booking Cancel",
];
export const bookingStatusColor = ["#000", "#ff9f40", "green", "green", "red"];
export const raiseTicketStatus = [strings.notavailable, "Open", "Close"];
export const raiseTicketStatusColor = [strings.notavailable, "green", "red"];
export const genderCheck = [strings.notavailable, "Male", "Female"];

export const MasterType = {
  0: strings.notavailable,
  1: strings.propertyType,
  2: strings.propertyConfiguration,
  3: strings.propertyAmenity,
  4: strings.insentiveType,
  5: strings.followupStatus,
  6: strings.leadFollowup,
  7: strings.propertyUnsubscribeResion,
  8: strings.leadCancle,
  9: strings.appointmentType,
  10: strings.PaymentType,
  11: strings.SupportType,
  12: strings.unitType,
  13: strings.leadSource,
  14: strings.cluster,
  15: strings.ethniCity,
};
export const MasterTypeHelper = {
  propertyType: 1,
  propertyConfiguration: 2,
  propertyAmenity: 3,
  insentiveType: 4,
  followupStatus: 5,
  leadFollowup: 6,
  propertyUnsubscribeReason: 7,
  leadCancel: 8,
  appointmentType: 9,
  paymentType: 10,
  support: 11,
  unitType: 12,
  leadSource: 13,
  ethniCity: 15,
};

export const channelPartnerUserType = {
  cp: 1,
  agent: 2,
};
export const ManagerType = {
  "63466085fadec47fe8e96bb7": strings.sourcingManager,
  "63731fd3d9363c459e31551f": strings.closingManager,
};

export const LoginType = [
  {
    value: 3,
    lable: "Web",
  },
  {
    value: 1,
    lable: "Mobile",
  },
];

// Role slugs
export const adminSlug = "channel_partner";
export const SubAdminSlug = "sub_admin";
export const HRSlug = "hr";
export const channelPartnerSlug = "channel_partner";
export const cpAgentSlug = "cp_agent";
export const SourcingTLSlug = "sourcing_tl";
export const ClosingTLSlug = "closing_tl";
export const PostSaleSlug = "post_sales";
export const CallCenterSlug = "call_center";
export const ReceptionistSlug = "receptionist";
export const SourcingManagerSlug = "sourcing_manager";
export const ClosingManagerSlug = "closing_manager";
export const SiteHeadSlug = "site_head";
export const clusterHeadSlug = "cluster_head";
export const vicePresidentSlug = "vice_president";

export const AdminRoleId = "6344049eb4f40996bcf1265a";
export const SourcingTL = "63464da503a33caee62c9cf2";
export const ClosingTL = "63731fafd9363c459e31550c";
/** CSTL: combination of Closing TL + Sourcing TL permissions (backend role). */
export const CSTL = "699da3b8bad4168bbfd67a5d";
export const PostSale = "63732009d9363c459e315530";
export const CallCenter = "63732080d9363c459e3155a2";
export const Receptionist = "6373202cd9363c459e315551";
export const SourcingManager = "63466085fadec47fe8e96bb7";
export const ClosingManager = "63731fd3d9363c459e31551f";
export const CPAgent = "6373209fd9363c459e3155b6";
export const ChannelPartner = "6346a40364de88d6385d4e38";
export const SubAdmin = "63c788aa311b6c78c2fe4603";
export const HR = "63c7944291b8c8f0e4dcfb3a";
export const SupportRequest = "64157f0d45f2102779cc159f";
export const SiteHead = "63d37697b29929d68de050f9";
export const ClusterHead = "63da1736ee01b8d62ceb7ea2";
export const BusinessHead = "63da1b26ee01b8d62ceb81d3";
export const scm_id = "66f64e74bf01ef6a7a59c501";
export const sourcing_head_id = "66f64d5ebf01ef6a7a59c3de";
export const closing_head_id = "66f654a587d9df88e43b17b4";
export const admin_id = "6703d823a38e367e30eed8e5";
/** JUSTO-64: Guest Relations Executive – role ID for GRE; GRE allocates visitors to CM/SCM only. */
export const GRE = "693fa2142f470759aa57a8f0";
export const SCM = "66f64e74bf01ef6a7a59c501";
export const SourcingHead = "66f64d5ebf01ef6a7a59c3de";

export const channelPartnerMaster = "645b3a414194e4010913546c";
export const referenceMaster = "645b3a524194e40109135470";
export const exhibitionMaster = "6703dd223cd31cb5d2d14320";
export const directWalkinMaster = "63ecd90787f864d94a3882ee";
export const referralPartnerMaster = "675a8359dd8bb8672316ca6e";

export const MIS_RoleId = "6838006caef2d658ebc272ff";

export const nextDaycallId = "6360c6d52ca46e9d3636fbf4";

export const propertyrole = [
  {
    _id: "63464da503a33caee62c9cf2",
    role_title: "Sourcing TL",
  },
  {
    _id: "63731fafd9363c459e31550c",
    role_title: "Closing TL",
  },
  {
    _id: "63732009d9363c459e315530",
    role_title: "Post Sale",
  },
  {
    _id: "63732080d9363c459e3155a2",
    role_title: "Call Center",
  },
  {
    _id: "6373202cd9363c459e315551",
    role_title: "Receptionist",
  },
  {
    _id: "63d37697b29929d68de050f9",
    role_title: "Site Head",
  },
];

export const leadType = [
  {
    value: "Hot",
  },
  {
    value: "Warm",
  },
  {
    value: "Cold",
  },
];

export const sourcingManagerSlug = "63d9f1faee01b8d62ceb54d1";
